export default class SepaDirectDebitExportAvailability {

    constructor() {
        this.isAvailable = false;
        this.messages = [];
        this.hasRunningExport = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let availability = new SepaDirectDebitExportAvailability();
        availability.isAvailable = data.isAvailable;
        availability.messages = data.messages;
        availability.hasRunningExport = data.hasRunningExport;

        return availability;
    }

}
